module.exports = __webpack_public_path__ + "static/media/add-bar.2d634835.jpg";